export const DESKTOP_BANNER_WIDTH = 728;
export const DESKTOP_BANNER_HEIGHT = 90;
export const MOBILE_BANNER_WIDTH = 320;
export const MOBILE_BANNER_HEIGHT = 100;
